module.exports = (__parcel__import__("27JuC")).then(() => parcelRequire('4MKVl'));